import { ChevronLeft } from "lucide-react";
import clsx from "clsx";

type NavigationArrowProps = {
  className?: string;
  direction: "left" | "right";
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const NavigationArrow = ({ className, direction, onClick }: NavigationArrowProps) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        "absolute bottom-0 top-0 z-[1] my-auto flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-black bg-opacity-60 text-white opacity-0 transition-opacity duration-300 group-hover/carousel:opacity-100",
        direction === "left" ? "left-2.5" : "right-2.5",
        className
      )}
    >
      <ChevronLeft size={30} className={clsx(direction === "right" ? "rotate-180" : null)} />
    </button>
  );
};

export default NavigationArrow;
